module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-meet-team ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (!_vm.loading) ? _c('main', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.props.acf.you_want_add_second_title_) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title_second)
    }
  })]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  })])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_c('picture', [_c('img', {
    attrs: {
      "src": _vm.props.better_featured_image.source_url,
      "alt": _vm.props.better_featured_image.alt_text
    }
  })])])])])])])]), _c('div', {
    staticClass: "saprater-mian"
  })]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cceab77e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/abo-certification/abo-certification.pug
// module id = 573
// module chunks = 1